import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[appTwoDigitDecimalPrice]',
})
export class TwoDigitDecimalPriceDirective {
  private regex = new RegExp(/^\d*\,?\d{0,2}$/g);
  private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const positionEnd = this.el.nativeElement.selectionEnd;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? ',' : event.key, current.slice(positionEnd)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}